import { Button, Form, Modal } from "react-bootstrap";
import { Dashboard } from "../../../core/interface/dashboard";
import "./edit-dashboard-modal.scss";
import { useEffect, useState } from "react";
import { initializeLogger } from "../../../core/config/config.initializer";
import { Logger, LogLevel } from "@core/logger";
import { CommonState } from "../../../core/interface/common-state";
import { axiosGet, axiosPost, axiosPut } from "../../../core/services/http-call.service";
import { DashboardDetail, Templatejson } from "../../../core/interface/dashboard-detail";
import { CommonResponse } from "../../../core/interface/common-response";

export default function SaveEditDashboard(props: {
  showModal: boolean,
  handleCloseModal: any,
  dashboard?: Dashboard | null,
  dashboardDetail?: DashboardDetail | null,
  isEdit: boolean
}) {

  let logger: Logger = initializeLogger();
  const formConfig = [
    {
      id: 'field1',
      name: 'title',
      inputType: "text",
      defaultValue: '',
      isHidden: false,
      isrequired: true,
      placeholder: 'Bulletin title'
    },
    {
      id: 'field2',
      name: 'description',
      inputType: "text",
      defaultValue: '',
      isHidden: false,
      isrequired: true,
      placeholder: 'Description for dashbaord'
    }
  ];
  const [stateObject, setStateObject] = useState<CommonState>({
    showErrorModal: false, callInProgress: false, statusMessage: ''
  });

  function validate() {
    let newErrors: { [key: string]: string } = {};
    formConfig?.forEach((field) => {
      if (field.isrequired && !formData[field.name]) {
        newErrors[field.name] = `${field.name} is required`;
      } else if (field.inputType === "email" && formData[field.name] && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData[field.name])) {
        newErrors[field.name] = "Invalid email format";
      }
    });
    setErrors(newErrors);
    Object.keys(newErrors).length === 0 ? logger.log(LogLevel.DEBUG, "Login form validation passed") : logger.log(LogLevel.WARNING, "Login form validation failed");
    return Object.keys(newErrors).length === 0;
  };

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors((prevErrors) => ({ ...prevErrors, [e.target.name]: undefined }));
  };

  const initialFormState = formConfig?.reduce((acc, field) => {
    acc[field.name] = field.defaultValue ?? "";
    return acc;
  }, {} as { [key: string]: string });

  const [formData, setFormData] = useState(initialFormState || {});
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});

  useEffect(() => {
    if (props.isEdit == true) {
      setFormData({
        title: props.dashboard?.dashboardTitle || props.dashboardDetail?.title || "",
        description: props.dashboard?.dashboardDescription || props.dashboardDetail?.description || "",
      });
    }
    setStateObject({ callInProgress: false, showErrorModal: false, statusMessage: "" });
  }, [props.dashboard]);

  async function saveDashboard(e: React.FormEvent) {
    e.preventDefault();
    // console.log(props.dashboardDetail)
    if (validate()) {
      setStateObject({ callInProgress: true, showErrorModal: false, statusMessage: "" });
      if (!props.isEdit) {
        //@ts-ignore
        let reqObj: DashboardDetail = { ...props.dashboardDetail, template_json: props.dashboardDetail?.template_json.map(widget => ({ ...widget, content: { ...widget.content, chartOptionsObject: (widget.content.chartOptionsObject.map((val) => ({ ...val, spec: { ...val.spec, data: { ...val.spec.data, values: [] } } }))) } })) };
        if (props.dashboardDetail?.id == 0) {
          reqObj = { ...reqObj, title: formData.title, description: formData.description }
        }
        await axiosPost(import.meta.env.VITE_API_HOST + '/dashboard', props.dashboard || reqObj || {});
      } else {
        let dashboardDetailResp: CommonResponse = await axiosGet(import.meta.env.VITE_API_HOST + `/dashboard/${props.dashboard?.dashboardId || props.dashboardDetail?.id}`);
        let reqObj: DashboardDetail = dashboardDetailResp.data;
        let cleanedTemplate: Templatejson[] = props.dashboardDetail?.template_json.map(widget => ({ ...widget, content: { ...widget.content, chartOptionsObject: (widget.content.chartOptionsObject.map((val) => ({ ...val, spec: { ...val.spec, data: { ...val.spec.data, values: [] } } }))) } })) || [];
        reqObj = { ...reqObj, title: formData.title, description: formData.description, template_json: cleanedTemplate || [] }
        await axiosPut(import.meta.env.VITE_API_HOST + `/dashboard/${props.dashboard?.dashboardId || props.dashboardDetail?.id}`, reqObj);
      }
      setStateObject({ callInProgress: false, showErrorModal: false, statusMessage: "" });
      props.handleCloseModal();
    }
  }

  return (
    <Modal className="dashboard-modal-style-1" show={props.showModal} onHide={props.handleCloseModal} centered>
      <Form className="pull-left" onSubmit={saveDashboard}>
        <div className="modal-body">
          {
            props.isEdit ? <h2>Edit bulletin details</h2> : <h2>Save bulletin</h2>
          }
          {formConfig?.map(field => (
            !field.isHidden && (
              <Form.Group className="mb-3" controlId={field.id} key={field.id}>
                <Form.Control type={field.inputType} name={field.name} placeholder={field.placeholder} value={formData[field.name]}
                  onChange={handleChange} isInvalid={!!errors[field.name]} required={field.isrequired} autoComplete="false" />
                <Form.Control.Feedback type="invalid">{errors[field.name]}</Form.Control.Feedback>
              </Form.Group>
            )
          ))}
        </div>
        <div className="modal-footer">
          <Button className="btn" onClick={props.handleCloseModal}>Close</Button>
          <Button type="submit" className="btn" disabled={stateObject.callInProgress}>
            {stateObject.callInProgress ? <span className="spinner-border spinner-border-sm btn-sm" role="status" aria-hidden="true"></span> : <></>}
            <span className="button-text">Submit</span>
          </Button>
        </div>
      </Form>
    </Modal>
  )
}